/** 契約書フォーマット格納ディレクトリパス */
export const CONTRACT_FORMAT_DIR_PATH = '/contract_formats/';
/** 契約書フォーマットファイルアイコン格納ディレクトリパス */
export const CONTRACT_FORMAT_ICON_DIR_PATH =
  CONTRACT_FORMAT_DIR_PATH + 'icons/';

/** 契約書フォーマットファイル一覧 */
export const formatFiles = [
  {
    name: 'kojiukeoi.xlsx',
    name_jp: '工事請負契約書.xlsx',
    icon: 'excel.svg'
  },
  {
    name: 'kojiukeoikihon.docx',
    name_jp: '工事請負基本契約書.docx',
    icon: 'word.svg'
  },
  {
    name: 'kojichumon.xlsx',
    name_jp: '工事注文書・請書.xlsx',
    icon: 'excel.svg'
  },
  {
    name: 'hikiwatashi.xlsx',
    name_jp: '工事物件引渡確認書.xlsx',
    icon: 'excel.svg'
  },
  {
    name: 'kojihosho.docx',
    name_jp: '工事保証書.docx',
    icon: 'word.svg'
  },
  {
    name: 'kimitsujoho.docx',
    name_jp: '機密情報等保持契約書.docx',
    icon: 'word.svg'
  }
];
